import { z } from "zod"
import { Network } from "@/config/tokens"
import { zodResolver } from "@hookform/resolvers/zod"
import { ResolverOptions } from "react-hook-form"

export const paymentFormSchema = z.object({
  name: z.string().min(1, { message: "First name is required" }),
  email: z.string().email(),
  network: z.nativeEnum(Network),
  amount: z
    .string()
    .min(0)
    .regex(/^[0-9]+(\.[0-9]{1,6})?$/, {
      message: "Amount must be a valid value with up to 6 decimal places",
    })
    .transform((v) => parseFloat(v)),
})

export const paymentFormResolver = (amountOptions?: {
  min?: number;
  max?: number;
}) => {
  return async (
    data: z.input<typeof paymentFormSchema>,
    context = undefined,
    options: ResolverOptions<z.input<typeof paymentFormSchema>>,
  ) => {
    const result = await zodResolver(paymentFormSchema)(data, context, options)

    if (amountOptions) {
      const errors = result.errors as Record<string, { message: string }>
      if (amountOptions.min && Number(data.amount) < amountOptions.min) {
        errors.amount = {
          message: `Amount must be at least ${amountOptions.min}`,
        }
      }
      if (amountOptions.max && Number(data.amount) > amountOptions.max) {
        errors.amount = {
          message: `Amount must be at most ${amountOptions.max}`,
        }
      }
    }

    return result
  }
}
